<template>
  <div>
    <Chart
      v-if="dataset.data.length>0"
      :data="dataset.data" :labels="dataset.labels" 
      @drill="onDrill" @clear="onClear"
      :title="title"
    />
    <div v-else class="d-flex flex-column align-center mt-8">
      <v-icon size="100px" color="yellow darken-2">
        mdi-emoticon-sad-outline
      </v-icon>
    </div> 
  </div>
</template>

<script>
  import Chart  from './chart';

  export default {
    name: 'DashboardChartBase',

    props: {
      limit: Number, 
      days: Number,
    },

    components: { Chart },

    computed: {
      title: () => 'click on the chart to filter',
    },

    methods: {
      onDrill(index) { this.$emit('drill', this.dataset.ids[index])},
      onClear() { this.$emit('clear') },
    },

    watch: {
      days() {
        this.load({ limit: this.limit, days: this.days, })
      },
    },

    created() {
      this.load({ limit: this.limit, days: this.days, })
    }
  }
</script>
